if(!customElements.get('header-menu')){
  customElements.define('header-menu', class HeaderMenu extends HTMLElement {
    constructor() {
      super();

      this.panel_1_items = this.querySelectorAll('.panel-1-menu-item.has-child-menu')

      if (this.panel_1_items.length === 0) {
        return;
      }

      this.panel_1_items.forEach(item => {
        item.addEventListener('mouseover', () => {
          this.showSubmenu(item);
        });

        item.addEventListener('focusin', () => {
          this.showSubmenu(item);
        });

        item.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.showSubmenu(item);
            const data_id = item.querySelector('a').getAttribute('data-id');
            const submenu = this.querySelector(`.panel-2-item[data-id="${data_id}"]`);
            if (submenu) {
              const firstLink = submenu.querySelector('a');
              if (firstLink) firstLink.focus();
            }
          } else if (e.key === 'Escape') {
            this.hideAllSubmenus();
            item.querySelector('a').focus();
          }
        });
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.hideAllSubmenus();
        }
      });
    }

    showSubmenu(item) {
      const data_id = item.querySelector('a').getAttribute('data-id');
      this.querySelectorAll('.panel-2-item').forEach(subitem => {
        if(data_id === subitem.getAttribute('data-id')) {
          subitem.classList.remove('hidden-menu');
        } else {
          subitem.classList.add('hidden-menu');
        }
      });
    }

    hideAllSubmenus() {
      this.querySelectorAll('.panel-2-item').forEach(subitem => {
        subitem.classList.add('hidden-menu');
      });
    }
  })
}